import script from "./new-user.vue?vue&type=script&lang=ts&setup=true"
export * from "./new-user.vue?vue&type=script&lang=ts&setup=true"

import "./new-user.vue?vue&type=style&index=0&id=7ee549c6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee549c6"]])

export default __exports__